import API from 'services/api.js';
import axios from 'axios';
import
	React,
	{
	// 	//useState,
		useEffect
	} from 'react';
import {
 	useSelector,
	//useDispatch,
} from 'react-redux';
import { useHistory } from 'react-router-dom'
import jwt from 'jwt-decode'
import { store } from 'index.js';
import {
	URL_AUTH_LOGIN,
	URL_AUTH_LOGOUT,
	URL_GET_USER_AUTHORISATION,
	URL_OWAUTH_LOGIN,
} from 'services/urls.js'

import {
	actionSetMessage,
	//actionResetMessages
} from 'components/messages/actions.js';
import { Redirect } from 'react-router-dom';

//import cookie from 'react-cookies'

export const SET_AUTH_LOADING = 'SET_AUTH_LOADING';
export const UPDATE_USER = 'UPDATE_USER';
export const RESET_USER = 'RESET_USER';
export const UPDATE_TOKENS = 'UPDATE_TOKENS';
export const RESET_TOKENS = 'RESET_TOKENS';
export const UPDATE_AUTH = 'UPDATE_AUTH';
export const RESET_AUTH = 'RESET_AUTH';

export const DefCurrentUser = {
	username: '',
	email: '',
	'cognito:groups': [],
}

// export const loadAuthFromCookies = () => {
// 	//clientId = clientId.match(/[0-9]+/g) || [''];
// 	return (dispatch) => {

// 		const idToken = cookie.load('idToken')
// 		try { // fails silently if not logged in and no cookie
// 			const userObj = jwt(idToken);
// 			//console.log('loadAuthFromCookies() - userObj', userObj)
// 			//console.log('dispatch(actionUpdateUserObject)', userObj)
// 			dispatch(actionUpdateUserObject(userObj))
// 		}
// 		catch(error) {
// 			console.log('not logged in idToken', idToken)
// 		 	//throw new error('xxxxx')
// 		}
// 	}
// }

/**
 * Checks if an auth token exists and is expired.
 * Refreshed the token if expired.
 *
 * returns true if successful
 * diverts to login if failed
 */

export const checkTokenExpiration = async () => {
	//console.log('checkTokenExpiration() - start')
	let response = true;
	/**
	 * This is non standard code as the store should be accessed outside of the react component
	 * https://daveceddia.com/access-redux-store-outside-react/
	 */
	try {
		const state = store.getState();
		if (state.tokens.exp === undefined || (state.tokens.exp - 60) < (Date.now() / 1000)) {// expired
			//console.log('Token expired - need to refresh tokens')
			await actionRefreshTokens();
		}
		//console.log('Token NOT expired')
	} catch(err){
		console.log('Error getting user token exp - log out user', err);
		await actionLogoutUser();
		response = false;
	}
	//console.log('checkTokenExpiration() - end')
	return response;
};

const actionResetUserObject = () => ({
   type: 'RESET_USER'
})

const actionUpdateUserObject = (userObj) => ({
	type: 'UPDATE_USER',
	payload: userObj
})

const actionResetTokens = () => ({
	type: 'RESET_TOKENS'
 })

 const actionUpdateTokens = (tokens) => ({
	 type: 'UPDATE_TOKENS',
	 payload: tokens
 })

// export const clearUserCookies = () =>{
// 	//console.log('actionLogoutUser()')
// 	cookie.remove('accessToken', {path: '/'})
// 	cookie.remove('idToken', {path: '/'})
// 	cookie.remove('tokenType', {path: '/'})
// 	//console.log('cookies removed')
// 	//console.log('YYYYY', cookie.load('idToken'))
// 	return
// }

export const actionCognitoSignout = () =>{
	window.location.href = URL_AUTH_LOGOUT;//	initiate Cognito login
}

export const actionLogoutUser = () => {
	//console.log('actionLogoutUser()')
	//actionCognitoSignout()
	//setInterval(actionLoginUser(),500);
	//return (dispatch) => {
		//store.dispatch(actionResetUserObject())
		//store.dispatch(actionResetTokens());
		store.dispatch(actionSetAuthLoading(true));

		//console.log(`calling axios DELETE on ${URL_OWAUTH_LOGIN}`);
		return axios.delete(URL_OWAUTH_LOGIN, { withCredentials: true })
		.then(response => {
			//console.log('actionLogoutUser() response',response);
			store.dispatch(actionResetUserObject());
			store.dispatch(actionResetTokens());
		})
		.catch(error => {
			console.log('actionLogoutUser() error', error);
			if (error.response) {
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				console.log('e data', error.response.data);
				console.log('e status', error.response.status);
				console.log('e headers', error.response.headers);
				// if (error.response.status === 400){// auth error
				// 	console.log('400 error', error)
				// 	actionLoginUser();
				// } else if (error.response.status === 500){// server error
				// 	console.log('500 error', error)
				// 	store.dispatch(actionSetMessage('Server error (500): ' + error))
				// } else {//	unknown app error
				// 	console.log('not 400 or 500 error', error)
				// 	store.dispatch(actionSetMessage('App error: ' + error))
				// }
			} else if (error.request) {
				// The request was made but no response was received
				// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
				// http.ClientRequest in node.js
				//store.dispatch(actionSetMessage('No server response: ' + error.request))
			} else {
				// Something happened in setting up the request that triggered an Error
				console.log('Error msg', error.message);
				//store.dispatch(actionSetMessage('Error (unknown): ' + error.message))
			}
		}).finally(()=>{
			store.dispatch(actionSetAuthLoading(false));
		});
	//}
}

export const isSuperuser = (currentUser) =>{
	//console.log('currentUser', currentUser)
	if (currentUser['cognito:groups'] === undefined){
		return false;
	} else if (currentUser['cognito:groups'].includes("superusers") > 0){
		return true;
	}
	return false
}

const getGroups = ( authorisation, clientId) => {
	//console.log('getGroups()',{authorisation: authorisation, clientId: clientId})
	if (clientId > 0 && authorisation.length > 0){
		return authorisation.reduce(function (res, set) {
			if (set.clientId === parseFloat(clientId)) {
				res.push(set.groupCode);
			}
			return res;
		}, []);
	}
	return []
}

const isUserInGroup = (authorisation, clientId, groupName) =>{
	//console.log('isUserInGroup()',{authorisation: authorisation, clientId: clientId, groupName: groupName})
	const groups = getGroups(authorisation, clientId)
	//console.log('groups', groups)
	if (groups.includes(groupName) > 0){
		//console.log('user is on group '+groupName)
		return true
	} else if (groupName === 'user' && groups.includes('admin') > 0){//admin inherits user rights
		//console.log('user is admin inherits user rights')
		return true
	}
	//console.log('user does NOT have group authorisation')
	return false
}

/**
 *
 * Use this method to return true/false if user has permission
 * to groupName priveledges for the clientId
 */

 export const getUserGroupAuth = (currentUser, clientId, authorisation, groupName) =>{
	//console.log('currentUser', currentUser)
	//console.log('authorisation', authorisation)
	//console.log('groupName', groupName)
	//console.log('clientId', clientId)

	if (currentUser.username.length < 3){//fail
		//console.log('getUserGroupAuth FAIL1')
		return false
	}
	if (isSuperuser(currentUser) || isUserInGroup(authorisation, clientId, groupName)){
		//console.log('getUserGroupAuth PASSED')
		return true
	} else {// no privileges
		//console.log('getUserGroupAuth FAIL2')
		return false
	}
 }

/**
 * Use this React component to limit access to a page based on user group membership
 * @param {*} props
 */
export const CheckAuth = (props) => {
	const currentUser = useSelector(state => state.currentUser);
	const authorisation = useSelector(state => state.authorisation);
	const clientId = useSelector(state => state.clientId);
	//console.log('currentUser', currentUser)
	//console.log('authorisation', authorisation)
	const { groupName } = props
	//console.log('groupName', groupName)
	const history = useHistory();
	useEffect(() => {
		if (!getUserGroupAuth(currentUser, clientId, authorisation, groupName)){
			//console.log('CheckAuth FAIL');
			history.push('/')
		}
	},[currentUser, authorisation, clientId, groupName, history])
	return ( null )
}

/**
 * AuthLoading flag is a global used to hide screens etc while the token
 * loading system completes. It is used to avoid page flicker etc
 */

export const actionSetAuthLoading = (status) => {
	return {type: SET_AUTH_LOADING, status}
}

/**
 * ##### user authorisation - from db mapping table
 *
 */

export const actionResetAuthorisation = () => {
	return {type: RESET_AUTH,}
}

export const actionSetAuthorisation = (data) => {
	return {
		type: UPDATE_AUTH,
		data
	}
}

export const actionFetchAuthorisation = () => {
	//console.log('actionFetchSessionIds()')
	return (dispatch) => {
		//dispatch(actionResetMessages())
		const params = {
			//params: {clientId: clientId,},
		}
		//if (checkTokenExpiration()){
			return API.get(URL_GET_USER_AUTHORISATION, params)
			//return axios.get(URL_GET_USER_AUTHORISATION, params)
			.then(response => {
				//console.log('actionFetchAuthorisation() response',response.data)
				dispatch(actionSetAuthorisation(response.data))
			})
			.catch(error => {
				console.log('error', error)
				dispatch(actionSetMessage('Error fetching user authorisation: ' + error))
			});
		//}
	};
};

export const actionLoginUser = () =>{
	window.location.href = URL_AUTH_LOGIN;//	initiate Cognito login
}


const setCurrentUser = async (idTokenObj) =>{
	//let idTokenObj = jwt(id_token);
	//console.log('idTokenObj', idTokenObj)
	//console.log('dispatch updated currentuser')
	await store.dispatch(actionUpdateUserObject(
		{
			username: idTokenObj['cognito:username'],
			email: idTokenObj.email,
			'cognito:groups': idTokenObj['cognito:groups'],
		}
	));
	return;
}


/**
 * actionFetchTokens()
 * Calls the auth API (POST) to get the real tonens and user object.
 * The tokens are saved automatically in the cookies and sent with the browser in each call to the auth api domain
 *
 * Need to store the user user objects separately to the token/expiries so the tokens can be refreshed
 * without triggering the listeners on the change of user. Without this loop behavior occurs.
 *
 * @param {*} code
 */

const actionFetchTokens = (code) => {
	//console.log('start actionFetchTokens()')
	store.dispatch(actionSetAuthLoading(true));
	const config = {
		headers: {
			'Content-Type': 'application/json',// Overwrite Axios's automatically set Content-Type
		},
		withCredentials: true
	}
	const json = JSON.stringify({authorisation_code: code})
	//console.log('before axios call')
	//console.log('URL_OWAUTH_LOGIN',URL_OWAUTH_LOGIN);
	//console.log('json', json)
	//console.log('config', config)

	return axios.post(URL_OWAUTH_LOGIN, json, config)
	.then(response => {
		//console.log('actionFetchTokens() response', response)
		const idTokenObj = jwt(response.data.tokens.id_token);
		setCurrentUser(idTokenObj);
		store.dispatch(actionUpdateTokens({...response.data.tokens, ...{exp: idTokenObj.exp}}));// include the expiry in the token data
		//console.log('dispatch updated tokens')
		//console.log('end actionFetchTokens()')

	}).catch(error => {
		console.log('actionFetchTokens() error',error);
		if (error.response) {
			// The request was made and the server responded with a status code
			// that falls out of the range of 2xx
			//console.log('e data', error.response.data);
			//console.log('e status', error.response.status);
			//console.log('e headers', error.response.headers);
			if (error.response.status === 400){// auth error
				console.log('400 error', error)
				actionLoginUser();
			} else if (error.response.status === 500){// server error
				console.log('500 error', error)
				store.dispatch(actionSetMessage('Server error (500): ' + error))
			} else {//	unknown app error
				console.log('not 400 or 500 error', error)
				store.dispatch(actionSetMessage('App error: ' + error))
			}
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			store.dispatch(actionSetMessage('No server response: ' + error.request))
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log('Error msg', error.message);
			store.dispatch(actionSetMessage('Error (unknown): ' + error.message))
		}

	}).then(() =>{
		store.dispatch(actionSetAuthLoading(false));
		// console.log('redirect to home');
		// return (<Redirect  to="/" />)
	});
	//console.log('actionFetchTokens - end of function')
};

/**
 * actionRefreshTokens()
 *
 */
export const actionRefreshTokens = async () => {
	//console.log('actionRefreshTokens()')
	const state = store.getState();
	return await axios.get(URL_OWAUTH_LOGIN,{ withCredentials: true })
	.then(response => {
		//console.log('actionRefreshTokens() response', response.data)
		const idTokenObj = jwt(response.data.tokens.id_token);
		//console.log('userObj', userObj)
		if (state.currentUser.username.length < 3){
			setCurrentUser(idTokenObj);
		}
		//do NOT store exp with user - listeners will loop
		store.dispatch(actionUpdateTokens({...response.data.tokens, ...{exp: idTokenObj.exp}}));// include the expiry in the token data
		return  <Redirect  to="/" />
	})
	.catch(error => {
		console.log('error actionRefreshTokens()', error)
		if (error.response) {
			// The request was made and the server responded with a status code
			// that falls out of the range of 2xx
			//console.log('e data', error.response.data);
			//console.log('e status', error.response.status);
			//console.log('e headers', error.response.headers);
			if (error.response.status === 400){//	auth error
				console.log('400 error', error);
				actionLoginUser();
			} else if (error.response.status === 500){//	server error
				console.log('500 error', error);
				store.dispatch(actionSetMessage('Server error (500): ' + error))
			} else {
				console.log('not 400 or 500 error')
				store.dispatch(actionSetMessage('App error: ' + error))
			}
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log('e resuest',error.request);
			store.dispatch(actionSetMessage('No server response: ' + error.request))
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log('Error msg', error.message);
			store.dispatch(actionSetMessage('Error (unknown): ' + error.message))
		}
		//console.log('e json', error.toJSON());
	}).then(() => {
		//console.log('actionRefreshTokens() complete')
	});
};

export { actionFetchTokens };